import { Box, Button, Icon, MenuItem, Paper, Select, TextField, Typography, useTheme } from '@mui/material';
import { Environment } from '../../environment';

interface IDadosSelect {
  nameBD: string;
  descricao: string;
}

interface IFerramentasDaListagemProps {
  dadosSelecao?: IDadosSelect[];
  textoTitulo?: string;
  mostrarTextoTitulo?: boolean;
  textoDaBusca?: string;
  mostrarInputBusca?: boolean;
  mostrarInputBasicSelect?: boolean
  textoDoSelect?: string;
  aoMudarTextoDeBusca?: (novoTexto: string) => void;
  aoMudarTextoDoSelect?: (novoTextoselect: string) => void;
  textoBotaoNovo?: string;
  mostrarBotaoNovo?: boolean;
  aoClicarEmNovo?: () => void;
}
export const FerramentasDaListagemColhedor: React.FC<IFerramentasDaListagemProps> = ({
  textoDaBusca = '',
  textoTitulo = '',
  textoDoSelect = '',
  mostrarTextoTitulo = false,
  aoMudarTextoDeBusca,
  aoMudarTextoDoSelect,
  mostrarInputBusca = false,
  aoClicarEmNovo,
  textoBotaoNovo = 'Novo',
  mostrarBotaoNovo = true,
  mostrarInputBasicSelect = true,
  dadosSelecao =[],
}) => {
  const theme = useTheme();

  return (
    <Box
      gap={1}
      marginX={1}
      padding={1}
      paddingX={1}
      display="flex"
      alignItems="center"
      component={Paper}
    >
      {mostrarInputBasicSelect && (
        <Select
          sx={{width:120}}
          size="small"
          value={textoDoSelect}
          onChange={(event) => aoMudarTextoDoSelect?.(event.target.value)}
        >
          {dadosSelecao.map((item) => (
            <MenuItem key={item.nameBD} value={item.nameBD}>
              {item.descricao}
            </MenuItem>
          ))}
        </Select>
      )}

      {mostrarInputBusca && (
        <TextField
          size="small"
          value={textoDaBusca}
          placeholder={Environment.INPUT_DE_BUSCA}
          onChange={(e) => aoMudarTextoDeBusca?.(e.target.value)}
        />
      )}

      

      {mostrarTextoTitulo && (
        <Typography
          component="span"
          sx={{
            fontFamily: 'Arial, sans-serif',
          }}
        >
          {textoTitulo}
        </Typography>
      )}

      <Box flex={1} display="flex" justifyContent="end">
        {mostrarBotaoNovo && (
          <Button
            size='small'
            color='primary'
            disableElevation
            variant='contained'
            onClick={aoClicarEmNovo}
            endIcon={<Icon>add</Icon>}
          >{textoBotaoNovo}</Button>
        )}
      </Box>
    </Box>
  );
};